import React, { ReactNode } from "react";
import {
  Typography,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@kelp-dao/kernel-design-system";

export type TAccordianItemWrapper = {
  prefixLabel?: string;
  label: string;
  element: ReactNode;
  labelStyle?: React.CSSProperties;
  value?: string;
};
const AccordianItemWrapperV2 = ({
  prefixLabel,
  label,
  element,
  labelStyle,
  value = "accordion-item",
}: TAccordianItemWrapper) => {
  return (
    <AccordionItem value={value} className="border-none">
      <AccordionTrigger
        className="hover:no-underline px-0 md:px-8"
        iconClassName="text-button-secondary"
      >
        <div className="flex gap-1">
          {prefixLabel && (
            <Typography
              variant="xsmall"
              type="body"
              className="text-text-primary font-normal"
            >
              {prefixLabel}{" "}
            </Typography>
          )}
          <Typography
            variant="xsmall"
            type="body"
            className="text-text-primary font-normal"
            style={labelStyle}
          >
            {label}
          </Typography>
        </div>
      </AccordionTrigger>

      <AccordionContent className="pb-3 lg:pb-6 px-0">
        {element}
      </AccordionContent>
    </AccordionItem>
  );
};

export default AccordianItemWrapperV2;
